const base = {
  viewBox: '0 0 16 16',
  width: 16,
  height: 16,
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.25,
  strokeLinecap: 'square',
  'aria-hidden': true,
  focusable: false,
};

export function ArrowRight({ className = 'icon' }) {
  return (
    <svg {...base} className={className}>
      <path d="M2.5 8h10M9 4.5 12.5 8 9 11.5" />
    </svg>
  );
}

export function ArrowUpRight({ className = 'icon' }) {
  return (
    <svg {...base} className={className}>
      <path d="M4.5 11.5l7-7M5.5 4.5h6v6" />
    </svg>
  );
}

export function ArrowDown({ className = 'icon' }) {
  return (
    <svg {...base} className={className}>
      <path d="M8 2.5v10M4.5 9 8 12.5 11.5 9" />
    </svg>
  );
}

export function CopyIcon({ className = 'icon' }) {
  return (
    <svg {...base} className={className}>
      <path d="M5.5 5.5h7v7h-7zM3.5 10.5v-7h7" />
    </svg>
  );
}

export function CheckIcon({ className = 'icon' }) {
  return (
    <svg {...base} className={className}>
      <path d="M3 8.5 6.5 12 13 4.5" />
    </svg>
  );
}
